import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { PetitionPropsTwo } from "../../interface/posts";
import RepresentativeSemicontainer from "../representative-semicontainer";
import { RepresentativeDataList } from "../../interface/representative";

const PetitionFour = ({
  next,
  prev,
  petition_data,
  setPetition_data,
}: PetitionPropsTwo) => {
  const get_representative = (selected_id: any[]) => {
    setPetition_data((prev) => ({
      ...prev,
      target_representative_ids: selected_id?.map((id) => id?.toString()),
    }));
  };

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          height: "4px",
          background: "url(/assets/icons/posts/line-04.png)",
        }}
      />

      <Stack sx={{ mt: 3, px: 2 }}>
        <Typography
          color="black"
          variant="body2"
          sx={{
            fontSize: 15,
            fontWeight: 500,
          }}
        >
          Direct the Petition to the Right Representative (optional)
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#7991A4",
          }}
        >
          Kindly select the right representative to inform or tag
        </Typography>
      </Stack>

      <Stack
        sx={{ px: 2, my: 2 }}
        direction={"row"}
        justifyContent={"flex-end"}
      >
        <Chip
          label="Back"
          onClick={() => prev()}
          sx={{
            backgroundColor: "#92A5B5",
            color: "#fafafa",
            mx: 1,
          }}
        />
        <Chip
          label="Continue"
          onClick={() => next()}
          color="primary"
          sx={{
            color: "#fafafa",
            px: 1,
          }}
        />
      </Stack>
      <Stack
        sx={{
          my: 2,
          borderRadius: "8px",
          px: 2,
          height: 550,
        }}
      >
        <RepresentativeSemicontainer get_representative={get_representative} />
      </Stack>
    </Box>
  );
};

export default PetitionFour;
